/// Herkese açık sitenin tek doğruluk kaynağı: adres, şirket kimliği, fiyat.
/// Değişiklik buradan yapılır; şablonlar ve JSON-LD buradan okur.
import identity from './site-identity.json';

/// Adres site-identity.json'dan gelir: derleme betiği (scripts/site/build-site.mjs)
/// sitemap/robots için aynı dosyayı okur — tek kaynak.
export const SITE_URL: string = identity.siteUrl;
export const SITE_NAME = 'My PT';

/// Onaysız iddia içeren içerik (SSS maddeleri vb.) bu bayrak açılana kadar
/// gösterilmez. Kullanıcı onayı (Task 14 listesi) sonrası true yapılır.
export const CLAIMS_APPROVED = false;

/// Alt bilgideki ödeme logoları (Visa/Mastercard/Troy/PayTR). Web'den ödeme
/// (alt proje B) gelene kadar kapalı; açarken logo dosyaları da eklenmeli.
export const SHOW_PAYMENT_LOGOS = false;

/// Kök için sonda eğik çizgili, alt sayfalar için çizgisiz (www yok).
export function canonicalUrl(path: string): string {
  return path === '/' ? `${SITE_URL}/` : `${SITE_URL}${path}`;
}

export const STORE_LINKS = {
  appStore: 'https://apps.apple.com/tr/app/my-pt/id6762345220',
  googlePlay: 'https://play.google.com/store/apps/details?id=com.tahatolga.mypt',
} as const;

/// Organization JSON-LD `sameAs` için resmi sosyal hesaplar (mağaza bağlantılarına ek).
/// Hesap açılıp doğrulandığında tam adresi buraya bir satır olarak ekleyin, ör.
/// 'https://www.instagram.com/<hesap>', 'https://www.linkedin.com/company/<hesap>'.
/// Açılmamış/doğrulanmamış hesap EKLENMEZ (docs/research/2026-10-06-seo-geo-plan.md §2.3).
export const SOCIAL_PROFILES: readonly string[] = [];

export interface CompanyInfo {
  readonly legalName: string;
  readonly address: string;
  readonly streetAddress: string;
  readonly district: string;
  readonly city: string;
  readonly phoneDisplay: string;
  readonly phoneE164: string;
  readonly email: string;
  readonly taxOffice: string;
  readonly taxNumber: string;
  readonly mersis: string;
}

export const COMPANY: CompanyInfo = {
  legalName: 'AURA FİT Spor ve Sağlıklı Yaşam Merkezi A.Ş.',
  address: 'Konak Mah. Barış (120) Sok. İlman Plaza Blok No: 9/7 Nilüfer / Bursa',
  streetAddress: 'Konak Mah. Barış (120) Sok. İlman Plaza Blok No: 9/7',
  district: 'Nilüfer',
  city: 'Bursa',
  phoneDisplay: '+90 533 563 42 19',
  phoneE164: '+905335634219',
  email: 'info@mypt.com.tr',
  taxOffice: 'Çekirge V.D.',
  taxNumber: '1031374141',
  mersis: '0103137414100001',
};

export interface PlanInfo {
  readonly id: 'monthly' | 'yearly';
  readonly name: string;
  readonly priceDisplay: string;
  readonly priceValue: number;
  readonly periodLabel: string;
  readonly isoDuration: 'P1M' | 'P1Y';
  readonly note: string;
  readonly highlight: boolean;
}

/// KDV dahil, herkese aynı. 12 × 999 = 11.988 ₺; yıllık 9.999 ₺ → 1.989 ₺ ≈ 2 ay.
export const PLANS: readonly PlanInfo[] = [
  {
    id: 'monthly',
    name: 'Aylık',
    priceDisplay: '999 ₺',
    priceValue: 999,
    periodLabel: '/ ay',
    isoDuration: 'P1M',
    note: 'Her ay yenilenir',
    highlight: false,
  },
  {
    id: 'yearly',
    name: 'Yıllık',
    priceDisplay: '9.999 ₺',
    priceValue: 9999,
    periodLabel: '/ yıl',
    isoDuration: 'P1Y',
    note: 'Her yıl yenilenir · aylık ≈833 ₺',
    highlight: true,
  },
];

/// İki planda da aynı kapsam (kullanıcı onayına sunulacak — Task 14).
/// Kodda doğrulandı: "Taksitli ve peşin satış kaydı" (Installment modeli,
/// PaymentMethod.CASH) ve "Ders hatırlatma bildirimleri" (lesson-reminder.job).
export const PLAN_FEATURES: readonly string[] = [
  'Ders takvimi, iptal ve saat değişikliği talepleri',
  'Öğrenci (danışan) ölçüm ve gelişim takibi',
  'Ders paketi takibi ve üyelik satışı, kalan ders hakkı',
  'Taksitli ve peşin satış kaydı',
  'Ciro, tahsilat ve gider takibi',
  'Ders hatırlatma bildirimleri',
  'Öğrencilerle uygulama içi mesajlaşma',
  'iPhone, Android ve web paneli',
];

export const PLAN_FEATURES_NOTE = 'Aylık ve yıllık planların özellikleri aynıdır; yalnız ödeme dönemi değişir.';

export const TRIAL_TEXT = '14 gün ücretsiz · kredi kartı gerekmez';

/// "Satın al" hedefi. Web'den ödeme (alt proje B) gelene kadar satın alma
/// uygulama içinden yapılıyor → /fiyatlar'daki mağaza bölümüne gider.
/// B'de yalnız bu sabit değişir.
export const PURCHASE_LINK = { path: '/fiyatlar', fragment: 'indir' } as const;

/// "Üye ol" hedefi: web'de salon sahibi kaydı, 14 gün deneme. Kayıt ekranı
/// `tip=salon` ile salon sahibini seçili ve formu açık getirir.
export const TRIAL_LINK = { path: '/auth/register', queryParams: { tip: 'salon' } } as const;
export const TRIAL_CTA = '14 gün ücretsiz dene';
